import axiosApiInstance from 'utils/axios-api-instance'

export const insertChapterTextData = ({ htmlFile, chapter_id }) =>
	axiosApiInstance.post(`api/file/upload/chapter/${chapter_id}`, htmlFile)
